// themeConfig.ts
import { theme as antdTheme } from "antd";

export const lightAlgorithm = antdTheme.defaultAlgorithm;
export const darkAlgorithm = antdTheme.darkAlgorithm;

export const lightTheme = {
  name: "light",
  borderColor: "#AFAFAF",
  background: "#FFFFFF",
  textColor: "#000000",
  navBarColor: "#008dc4",
};

export const darkTheme = {
  name: "dark",
  borderColor: "#333333",
  background: "#120338",
  textColor: "#FFFFFF",
  navBarColor: "#000000",
};
